const CONTRACT_TYPE = {
    NFT: "NFT",
    MARKET: "MARKET",
    WRAPPER: "WRAPPER",
  };
  
  export default CONTRACT_TYPE;
  